export type Favorite = { id: string; title: string };
const KEY = "serendiptv.favorites.v1";

export function loadFavorites(): Favorite[] {
  try {
    const data: unknown = JSON.parse(localStorage.getItem(KEY) ?? "[]");
    if (!Array.isArray(data)) return [];
    const seen = new Set<string>();
    return data.filter((entry): entry is Favorite => {
      if (!entry || typeof entry.id !== "string" || !/^[0-9a-f-]{36}$/i.test(entry.id) || typeof entry.title !== "string" || seen.has(entry.id)) return false;
      seen.add(entry.id);
      return true;
    }).slice(-500).map(({ id, title }) => ({ id, title: title.slice(0, 500) }));
  } catch { return []; }
}

export function saveFavorites(favorites: Favorite[]): boolean {
  try { localStorage.setItem(KEY, JSON.stringify(favorites)); return true; }
  catch { return false; }
}
